import { render } from "./SingleSaleForEightCatalogy.vue?vue&type=template&id=791410a4&scoped=true"
import script from "./SingleSaleForEightCatalogy.vue?vue&type=script&lang=js"
export * from "./SingleSaleForEightCatalogy.vue?vue&type=script&lang=js"

import "./SingleSaleForEightCatalogy.vue?vue&type=style&index=0&id=791410a4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-791410a4"]])

export default __exports__